export default __webpack_public_path__ + "static/media/Notifications.b1bb45c6.svg";